var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { Checkbox } from '../elements/checkbox';
/**
 * EntityDataGridRowActions
 *
 * This component is used to render the row actions in the entity data grid.
 * This includes both a menu, and if necessary a checkbox rendered to the left of the menu
 * The checkbox should only appear if at least one row has been selected in the entire grid.
 * The flow for this is:
 * - nothing is selected: no checkbox
 * - one or more rows are selected: checkbox appears, and is checked if the row is selected
 *
 */
var cls = classNames('entity-data-grid-row-actions');
export var EntityDataGridRowActionsDefaultProps = {
  showCheckbox: false,
  isChecked: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var CheckboxStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'EntityDataGridRowActions',
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Checkbox: styled(Checkbox)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), CheckboxStyles)
};
export var EntityDataGridRowActions = function (props) {
  var componentProps = useComponentProps(My.NAME, EntityDataGridRowActionsDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    showCheckbox = componentProps.showCheckbox,
    menuButton = componentProps.menuButton,
    isChecked = componentProps.isChecked;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, showCheckbox && React.createElement(My.Checkbox, {
    checked: isChecked
  }), menuButton, children);
};
EntityDataGridRowActions.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;